/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Gift_MobileInputs */

const vi_shop_home_gift_mobile = /** @type {(inputs: Shop_Home_Gift_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chữ trên điện thoại`)
};

/**

* @param {Shop_Home_Gift_MobileInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_gift_mobile = /** @type {((inputs?: Shop_Home_Gift_MobileInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Gift_MobileInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_gift_mobile(inputs)
});